import React, { useState, useEffect } from 'react';
import { usePassword } from './hooks/usePassword';
import { Copy, RefreshCw, ShieldCheck, Check } from 'lucide-react';
import './App.css';

function App() {
  const [length, setLength] = useState(16);
  const [settings, setSettings] = useState({ includeNumbers: true, includeSymbols: true });
  const [copied, setCopied] = useState(false);
  
  const { password, generate, calculateStrength } = usePassword();
  const strength = calculateStrength(length, settings);

  // Auto-generate on mount and when settings change
  useEffect(() => { 
    generate(length, settings); 
  }, [length, settings, generate]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(password);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="app-container">
      <h1><ShieldCheck size={32} color="#8b5cf6" /> SecureGen</h1>
      
      <div className="output-box">
        <input type="text" readOnly value={password} />
        <button onClick={() => generate(length, settings)} title="Regenerate">
          <RefreshCw size={20} />
        </button>
        <button onClick={copyToClipboard} title="Copy">
          {copied ? <Check size={20} color="#00ff88" /> : <Copy size={20} />}
        </button>
      </div>

      <div className="strength-container" style={{ margin: '20px 0' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
          <span style={{ fontSize: '0.8rem', color: '#94a3b8' }}>Security Level</span>
          <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: strength.color }}>
            {strength.label}
          </span>
        </div>
        <div className="progress-bg" style={{ height: '8px', background: '#0f172a', borderRadius: '4px' }}>
          <div className="progress-bar" style={{ 
            height: '100%', 
            width: `${strength.percent}%`, 
            backgroundColor: strength.color,
            transition: 'width 0.3s ease, background-color 0.3s ease',
            borderRadius: '4px',
            boxShadow: `0 0 10px ${strength.color}`
          }} />
        </div>
      </div>

      <div className="controls">
        <label>
          <div className="label-header">
            <span>Password Length</span>
            <span style={{color: 'var(--primary)'}}>{length}</span>
          </div>
          <input 
            type="range" min="8" max="64" 
            value={length} 
            onChange={(e) => setLength(parseInt(e.target.value))} 
          />
        </label>

        <div className="checkbox-group">
          <label className="checkbox-tile">
            <input 
              type="checkbox" 
              checked={settings.includeNumbers} 
              onChange={() => setSettings(s => ({...s, includeNumbers: !s.includeNumbers}))} 
            />
            <span>Numbers</span>
          </label>

          <label className="checkbox-tile">
            <input 
              type="checkbox" 
              checked={settings.includeSymbols} 
              onChange={() => setSettings(s => ({...s, includeSymbols: !s.includeSymbols}))} 
            />
            <span>Symbols</span>
          </label>
        </div>
      </div>
    </div>
  );
}

export default App;